import { getEmergencyEvents, postEmergencyEvent, getEmergencyButtonStatus} from '../../../api/eastCoastMonitorApi/emergencyEventApi'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import moment from 'moment'

const state = {
  emergencyButtons: [],
  emergencyEvents: []
}

const getters = {
  getEmergencyButton: state => {
    return state.emergencyButtons
  },
  
  getTriggeredButton: state => {
    return state.emergencyButtons.filter(b => b.isTrigger === true)
  },

  getEvents: state => {
    return state.emergencyEvents
  },
}

const actions = {
  
  async getEmergencyButton({ commit }, condition = {}) {
    const result = await getEmergencyButtonStatus()
    if(result.success) {
      commit('emergencyButtons', result.data)
    }
  },
  
  async getEmergencyEvents({ commit }, condition = {}) {
    const result = await getEmergencyEvents(condition)
    if(result.success) {
      commit('emergencyEvents', result.data)
    }
  },

  async postEmergencyEvent({ commit }, event = {}) {
 
    const result = await postEmergencyEvent(event)
    console.log("postEmergencyEvent",result)
    if(result.success) {
      commit('updateEvent', { data: event, mode: 'post' })
    }
    return result
  }
}

const mutations = {
  emergencyButtons: (state, data) => {
    if(Utils.isEmptyObject(data)) {
      state.emergencyButtons = []  
    } else {
      state.emergencyButtons = data;
    }
    
  },

  emergencyEvents: (state, data) => {
    state.emergencyEvents = data
  },

  updateEvent: (state, { data, mode }) => {
    switch(mode) {
      case 'post':
        //更新event資料
        let target = state.emergencyEvents.filter(e => data.deviceEventIds.includes(e.eventId));  
  
        // console.log("t1",target)
        for(let i=0; i<target.length; i++){
          target[i].dismissContent = data.content;
          target[i].isDismiss = data.isDismiss;
          target[i].fillAccount = data.fillAccount;
          // target[i].fillTime = moment().format(); // 不更新填寫時間
        }

        break
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}